import CreateWork from '../views/support/CreateWork';
import MyWorkList from '../views/support/MyWorkList';
import MyWork from '../views/support/MyWork';
import AccountRecovery from '../views/support/accountRecovery';
export default [
  {
    path: '/',
    name: '',
    redirect: '/mylist',
  },
  {
    path: '/creatework',
    name: 'creatework',
    meta: {
      index: 3,
    },
    component: CreateWork,
  },
  {
    path: '/mylist',
    name: 'mylist',
    meta: {
      index: 2,
    },
    component: MyWorkList,
  },
  {
    path: '/mywork/:workId',
    name: 'mywork',
    meta: {
      index: 4,
    },
    component: MyWork,
  },
  {
    path: '/account',
    name: 'accountrecovery',
    component: AccountRecovery,
  },
];
